/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface CreateAddressDto
 */
export interface CreateAddressDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    street1?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    street3?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    streetNo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressDto
     */
    isDefault?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAddressDto
     */
    isResidential?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAddressDto
     */
    addressType?: CreateAddressDtoAddressTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateAddressDtoAddressTypeEnum {
    Billing = 'Billing',
    Shipping = 'Shipping',
    Both = 'Both'
}

